
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function SearchBoxRT () {
    return _createElement('form', { 'onSubmit': this.preventFormSubmission }, _createElement('div', { 'className': 'cm_search-box_form-container' }, [
        [this.searchInput(function () {
                return _createElement('div', { 'className': 'cm_searchInput' }, 'Type to search...');
            }, {
                widgetName: 'undefined',
                items: undefined
            })],
        _createElement('span', {
            'className': 'cm_search-box_clear-container',
            'key': '972'
        }, this.inputNotEmpty ? _createElement('span', {
            'className': 'cm_search-box_clear',
            'onClick': this.clearInput,
            'key': '395'
        }, '\n    ', window.innerWidth > 768 ? '\u2715' : 'Clear', '\n  ') : null),
        _createElement('button', {
            'type': 'button',
            'title': 'Search',
            'aria-label': 'search button',
            'className': 'cm_search-box_submit cm_button cm_button__primary',
            'data-cm-role': 'add-query',
            'key': '974'
        }, [_createElement('svg', {
                'className': '#icon',
                'key': '7290'
            }, _createElement('use', { 'href': '#svg-icon-magnifying-glass' }))])
    ]), [this.dropdown(function () {
            function repeatSections1(hasProductResults, sections, sectionsIndex) {
                return [sections(function () {
                        function repeatItems1(isProducts, items, itemsIndex) {
                            return [items(function () {
                                    function mergeProps_text(inline, external) {
                                        var res = Object.assign({}, inline, external);
                                        if (inline.hasOwnProperty('style')) {
                                            res.style = _.defaults(res.style, inline.style);
                                        }
                                        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                            res.className = external.className + ' ' + inline.className;
                                        }
                                        return res;
                                    }
                                    function mergeProps_product(inline, external) {
                                        var res = Object.assign({}, inline, external);
                                        if (inline.hasOwnProperty('style')) {
                                            res.style = _.defaults(res.style, inline.style);
                                        }
                                        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                            res.className = external.className + ' ' + inline.className;
                                        }
                                        return res;
                                    }
                                    function repeatI2_product(i, iIndex) {
                                        return _createElement('span', {
                                            'key': i,
                                            'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                                        });
                                    }
                                    function onError1_facetValue(e) {
                                        e.target.classList.add('cm_hide');
                                    }
                                    function mergeProps_facetValue(inline, external) {
                                        var res = Object.assign({}, inline, external);
                                        if (inline.hasOwnProperty('style')) {
                                            res.style = _.defaults(res.style, inline.style);
                                        }
                                        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                            res.className = external.className + ' ' + inline.className;
                                        }
                                        return res;
                                    }
                                    return this.template === 'text' ? _createElement('div', mergeProps_text({ 'className': (this.text === this.query ? 'active' : '') + ' cmTemplate_text' }, { dangerouslySetInnerHTML: { __html: this.textHighlight } })) : this.template === 'product' ? _createElement('div', { 'className': 'cmTemplate_product' }, _createElement('div', { 'className': 'image-block' }, _createElement('img', {
                                        'src': this.imageOrDefault(this.image),
                                        'alt': 'Image of ' + (this.removeHTML(this.sku) || this.removeHTML(this.title)),
                                        'onError': this.onImageError
                                    })), _createElement('div', { 'className': 'description-block' }, _createElement('div', mergeProps_product({ 'className': 'title' }, { dangerouslySetInnerHTML: { __html: this.title } })), _createElement('div', { 'className': 'price' }, '\n    ', this.price_varies ? `From: ${ this.formatPrice(this.price) }` : this.formatPrice(this.price), '\n  '), [this.review_count ? _createElement.apply(this, [
                                            'div',
                                            {
                                                'className': 'cm_review-stars',
                                                'key': '4680'
                                            },
                                            _map([
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ], repeatI2_product.bind(this)),
                                            _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                                        ]) : null])) : this.template === 'facetValue' ? _createElement('div', { 'className': 'cmTemplate_facetValue' }, this.imageUrl ? _createElement('div', {
                                        'className': 'image-block',
                                        'key': '35'
                                    }, _createElement('img', {
                                        'src': this.imageUrl,
                                        'alt': 'Image of ' + this.facetValue,
                                        'onError': onError1_facetValue.bind(this)
                                    })) : null, _createElement('div', { 'className': 'description-block' }, _createElement('div', mergeProps_facetValue({ 'className': 'title' }, { dangerouslySetInnerHTML: { __html: this.value } })), this.hitCount ? _createElement('span', {
                                        'className': 'hit-count',
                                        'key': '335'
                                    }, '(', this.hitCount, ')') : null)) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                                }, { count: undefined })];
                        }
                        function scopeIsProducts2() {
                            var isProducts = this.sectionTitle === 'Products';
                            return _createElement('div', {
                                'className': 'section' + (isProducts ? ' products' : hasProductResults ? ' queries' : ''),
                                'key': '3'
                            }, this.sectionTitle ? _createElement('div', {
                                'className': 'section-title-div',
                                'key': '217'
                            }, _createElement('div', { 'className': 'item section-title' }, '\n        ', isProducts ? 'Product Suggestions' : this.sectionTitle, !!this.vehicleString ? ` for
        ${ this.vehicleString }` : '', '\n      ')) : null, _createElement.apply(this, [
                                'div',
                                { 'className': 'cmRepeater_items' },
                                _map(this.items, repeatItems1.bind(this, isProducts))
                            ]), isProducts ? [[this.browseAllButton(function () {
                                        return _createElement('a', { 'className': 'item button-item cm_browseAllButton' }, '\n        See All Results For ', _createElement('span', { 'className': 'search-query' }, '"', this.query, '"'), [_createElement('svg', {
                                                'className': 'cm_icon cm_icon-angle right',
                                                'height': '20px',
                                                'role': 'img',
                                                'viewBox': '39 30 565 565',
                                                'aria-hidden': 'true',
                                                'key': '1430'
                                            }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))]);
                                    }, {
                                        widgetName: 'undefined',
                                        items: undefined
                                    })]] : null);
                        }
                        return this.items.length ? scopeIsProducts2.apply(this, []) : null;
                    }, { count: undefined })];
            }
            function scopeHasProductResults2() {
                var hasProductResults = this.hasProductResults;
                return _createElement.apply(this, [
                    'div',
                    { 'className': 'cmRepeater_sections' },
                    _map(this.sections, repeatSections1.bind(this, hasProductResults))
                ]);
            }
            return _createElement('div', { 'className': 'cm_autocomplete' + (!this.hasProductResults ? ' no-products' : '') + ' cm_dropdown' }, scopeHasProductResults2.apply(this, []), !this.hasProductResults ? _createElement('div', {
                'className': 'section message',
                'key': '6896'
            }, _createElement('span', { 'className': 'primary-text' }, ' Sorry, there are no products matching your selected vehicle. '), _createElement('p', {}, 'Feeling stuck? We\'ve got you! ', _createElement('br', {}), 'Call a Diesel Expert 208-719-7400')) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:searchInput","cm:browseAllButton","cm:dropdown"]